"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TickCrossIcons = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _brandConfigs = require("@PetSureAustralia/petsure-brand-partner-configs/distConfigs/brandConfigs");
var _tableContext = require("../../productsTable/stateHelpers/tableContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TickCrossIcons = exports.TickCrossIcons = function TickCrossIcons(_ref) {
  var value = _ref.value;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    brand = _useContext.tableContext.brand;
  var _ref2 = _brandConfigs.BrandConfigs[brand] || _brandConfigs.BrandConfigs["default"],
    icons = _ref2.quoteTools.productTable.icons;
  var tickIcon = icons && Object.hasOwn(icons, 'tick') ? /*#__PURE__*/_react["default"].createElement("img", {
    alt: "tick",
    src: icons.tick
  }) : /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "tick"
  });
  var crossIcon = icons && Object.hasOwn(icons, 'cross') ? /*#__PURE__*/_react["default"].createElement("img", {
    alt: "cross",
    src: icons.cross
  }) : /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "cross"
  });
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelValue"
  }, value ? tickIcon : crossIcon, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, "This feature is ", value ? 'included' : 'not included'));
};
TickCrossIcons.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string, _propTypes["default"].number])
};